import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=99662a66"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99662a66')) {
      api.createRecord('99662a66', component.options)
    } else {
      api.reload('99662a66', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=99662a66", function () {
      api.rerender('99662a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cron/config/custom/year/empty.vue"
export default component.exports